/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".new_button[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;border-radius:24px;min-width:224px;min-height:34px;border:1px solid #e0e0e0;background-color:#ff671d;color:#fff;font-size:16px;font-weight:700;cursor:pointer;padding:0 23px}@media (max-width:800px){.new_button[_ngcontent-%COMP%]{min-width:100%}}.new_button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-left:5px;margin-right:0}"];
export { styles as styles };
